// extracted by mini-css-extract-plugin
module.exports = {"mobile-header":"mobile-header___34Kzt","mobileHeader":"mobile-header___34Kzt","title":"title___1oyQ9","description":"description___1X5r7","kommersant":"kommersant___3t0R0"};